/**
 * Generate an array containing all pages to render.
 * @param totalPages
 * @param delta
 * @param currentPage
 * @returns {Array}
 */
export const getPagesArray = ({ totalPages, delta, currentPage }) => {
    let i
    let pages
    let startPage
    let endPage

    if (totalPages <= 2 * delta + 5) {
        // in this case, too few pages, so display them all
        startPage = 1
        endPage = totalPages
    } else if (currentPage <= delta + 3) {
        // in this case, currentPage is too close to the beginning
        startPage = 1
        endPage = 2 * delta + 1
    } else if (currentPage >= totalPages - (delta + 2)) {
        // in this case, currentPage is too close to the end
        startPage = totalPages - 2 * delta
        endPage = totalPages
    } else {
        // regular case
        startPage = currentPage - delta
        endPage = currentPage + delta
    }

    pages = []
    for (i = startPage; i <= endPage; i++) {
        pages.push(i)
    }

    return pages
}
